// Evidenziazione sul canvas delle gabbie trovate dalla ricerca in sidebar ("Cerca seriale o
// prodotto…"): le trovate diventano gialle con alone, le altre si attenuano. Colore volutamente
// fuori dalla scala degli stati (verde/blu/viola/arancio/rosso) per non confondersi con essi.
export const SEARCH_HIGHLIGHT_COLOR = "#facc15";

/**
 * Stato di ricerca di una gabbia: null = nessuna ricerca attiva, "match" = trovata, "dim" = no.
 * `matchIds` è null quando non c'è una query in corso.
 */
export function getZoneSearchState(matchIds, zoneId)
{
	if (!matchIds) return null;
	return matchIds.has(zoneId) ? "match" : "dim";
}

/**
 * Props Konva da stendere DOPO lo stile normale del rettangolo (vincono su colore e alone).
 * Le misure sono in px SCHERMO, quindi divise per lo `zoom` dello Stage: uno spessore fisso in
 * coordinate pagina a "pagina intera" (~20-30%) diventerebbe un filo di 1 px illeggibile. L'alone
 * è scuro apposta: il bordo giallo da solo si perde sulle foto gialle/crema dei volantini.
 */
export function zoneSearchHighlightProps(state, zoom = 1)
{
	if (state === "match")
	{
		const z = Math.max(Number(zoom) || 1, 0.05);
		return {
			stroke: SEARCH_HIGHLIGHT_COLOR,
			strokeWidth: 5 / z,
			fill: "rgba(250, 204, 21, 0.35)",
			shadowColor: "#111827",
			shadowBlur: 10 / z,
			shadowOpacity: 0.8,
			opacity: 1
		};
	}
	if (state === "dim")
		return {opacity: 0.25};
	return {};
}

/**
 * Centra nel contenitore scrollabile la gabbia `zone` (coordinate pagina full-res). Lo Stage dei
 * canvas di pre-elaborazione è traslato di `margin` px schermo e scalato di `zoom`, quindi la
 * posizione a video è margin + coordinata × zoom, relativa all'origine del contenitore dello Stage.
 * Ritorna false se contenitore o Stage non sono ancora montati (il chiamante riprova).
 */
export function scrollZoneIntoContainer(scrollEl, stageEl, zone, zoom, margin)
{
	if (!scrollEl || !stageEl || !zone) return false;
	const container = scrollEl.getBoundingClientRect();
	const stage = stageEl.getBoundingClientRect();
	const zoneW = Math.max(zone.w * zoom, 1);
	const zoneH = Math.max(zone.h * zoom, 1);
	const left = scrollEl.scrollLeft + (stage.left - container.left) + margin + zone.x * zoom;
	const top = scrollEl.scrollTop + (stage.top - container.top) + margin + zone.y * zoom;
	const maxLeft = Math.max(scrollEl.scrollWidth - scrollEl.clientWidth, 0);
	const maxTop = Math.max(scrollEl.scrollHeight - scrollEl.clientHeight, 0);
	scrollEl.scrollTo({
		left: Math.min(Math.max(left - (scrollEl.clientWidth - zoneW) / 2, 0), maxLeft),
		top: Math.min(Math.max(top - (scrollEl.clientHeight - zoneH) / 2, 0), maxTop),
		behavior: "smooth"
	});
	return true;
}
